import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';import { BankAccountService } from '../bancos/bankaccount.service';
import { BankAccountModel } from '../bancos/bankaccount.model';
import { consts } from '../../../consts';
import { PagoCuotasPrestamosModel, PrestamosModel } from './prestamos.model';
import { PrestamosListComponent } from './prestamos-list.component';
import { PrestamosService } from './prestamos.service';
import { ActivityModel } from '../../user/activity/activity.model';
import { ActivityService } from '../../user/activity/activity.service';
import { MasterModel } from '../../../modules_v2/master/models/master.model';
import { MasterService } from '../../../modules_v2/master/services/master.service';
import { ActualSelected } from '../../../shared/utils';

@Component({
    selector: 'convfact-prestamospagocuotas',
    templateUrl: './prestamos-dialog-pago-cuotas.component.html',
    styleUrls: ['./prestamos.component.css'],
    standalone: false
})
export class PrestamosDialogPagoCuotasComponent implements OnInit {

  public prestamos: PrestamosModel = this.data.prestamos;
  public pagoCuotasPrestamos: PagoCuotasPrestamosModel = new PagoCuotasPrestamosModel();

  public depositSaved: boolean = false;
  public ready: boolean = false;
  public isEditMode: boolean = false;
  public list: boolean = false;

  public bankAccounts: BankAccountModel[] = [];
  public dataSource: PagoCuotasPrestamosModel[] = [];

  public headerTable: any[] = [
    { field: 'fecha', title: 'Fecha', cell: (row) => `${new Date(row.fecha).toLocaleDateString()}`, class: (row) => `` },
    { field: 'importeCapital', title: 'Importe Capital', cell: (row) => `${row.importeCapital}`, class: (row) => `` },
    { field: 'intereses', title: 'Intereses', cell: (row) => `${row.intereses}`, class: (row) => `` },
    { field: 'bankAccountInfo', title: 'Banco / Tarjeta', cell: (row) => row.bankAccountInfo ? `${row.bankAccountInfo}` : '', class: (row) => `` },
  ];

  public invalidDate: boolean = false;
  public invalidConcept: boolean = false;
  public invalidImporteCapital: boolean = false;
  public invalidIntereses: boolean = false;
  public invalidBankAccount: boolean = false;

  public activities: ActivityModel[] = [];
  projects: MasterModel[] = [];
  expenseProjectTypes: MasterModel[] = [];
  isProjectEnable: boolean = false;

  paided: number = 0;
  remaining: number = 0;

  constructor(
    public dialogRef: MatDialogRef<PrestamosListComponent>,
    public prestamosService: PrestamosService,
    public bankAccountService: BankAccountService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public snackBar: MatSnackBar,
    public activityService: ActivityService,
    private masterService: MasterService,
    private cdr: ChangeDetectorRef,
  ) { }

  public ngOnInit(): void {
    this.activityService.getList().then(response => {
      this.activities = response;
    });

    this.activityService.loadData(ActualSelected.activitySelected).then(activity => {
      this.isProjectEnable = activity.isProject;
    });

    this.bankAccountService.getList().then(bankAccounts => {
      this.bankAccounts = bankAccounts.list;
    });

    this.masterService.getProjects().subscribe(data => {
      this.projects = data;
      this.cdr.detectChanges();
    });

    this.masterService.getExpenseProjectTypes().subscribe(data => {
      this.expenseProjectTypes = data;
      this.cdr.detectChanges();
    });

    this.getData();
  }

  public pay(): void {
    this.pagoCuotasPrestamos.prestamosId = this.prestamos.uid;
    let noError: boolean = true;

    if (!this.pagoCuotasPrestamos.fecha) {
      noError = false;
      this.invalidDate = true;
    }

    if (!this.pagoCuotasPrestamos.concepto) {
      noError = false;
      this.invalidConcept = true;
    }

    if (!this.pagoCuotasPrestamos.importeCapital) {
      noError = false;
      this.invalidImporteCapital = true;
    }

    if (!this.pagoCuotasPrestamos.bankAccountsUid || this.pagoCuotasPrestamos.bankAccountsUid === consts.EMPTY_GUID) {
      noError = false;
      this.invalidBankAccount = true;
    }

    if (!this.pagoCuotasPrestamos.activitiesUid) {
      noError = false;
    }

    //Pendiente de definir
    /*if (!this.pagoCuotasPrestamos.projectUid || !this.pagoCuotasPrestamos.expenseProjectTypeUid) {
      noError = false;
      this.displayInfo("Debe seleccionar un proyecto y un tipo de proyecto de gasto");
    }*/

    if (noError) {
      const request = this.isEditMode
        ? this.prestamosService.pagoCoutasUpdate(this.pagoCuotasPrestamos)
        : this.prestamosService.pagoCoutasCreate(this.pagoCuotasPrestamos);

      request
        .then(() => {
          this.depositSaved = true;
          this.closeDialog();
          this.displayInfo("Pago guardado correctamente.")
        })
        .catch(() => this.displayInfo("Ha ocurrido un error inesperado al guardar el pago"));
    } else {
      this.displayInfo("Compruebe que tiene los campos rellenados correctamente");
    }
  }

  onImporteCapitalChange(amount: any) {
    const valor = Number(amount);
    if (isNaN(valor)) return;

    this.paided = 0;

    this.dataSource.forEach(payment => {
      if (!this.isEditMode || payment.uid !== this.pagoCuotasPrestamos.uid) {
        this.paided += payment.importeCapital;
      }
    });

    this.paided += valor;
    this.remaining = this.prestamos.importePendiente - this.paided;
  }

  public getData(): void {
    this.depositSaved = false;
    this.ready = false;

    this.invalidDate = false;
    this.invalidConcept = false;
    this.invalidImporteCapital = false;
    this.invalidIntereses = false;
    this.invalidBankAccount = false;

    this.prestamosService.pagoCoutasList(this.prestamos.uid)
      .then(response => {
        this.dataSource = response;

        if (this.dataSource.length > 0) {
          this.dataSource.forEach(payment => this.paided += payment.importeCapital);
          this.remaining = this.prestamos.importePendiente;
          this.list = true;
        }
        this.ready = true;
      })
      .catch(() => {
        this.ready = true;
      });
  }

  public delete(uidElement: string): void {
    this.prestamosService.pagoCoutasDelete(uidElement)
      .then(() => {
        this.getData();
      })
      .catch(() => {
        this.displayInfo("Ha ocurrido un error al eliminar el Pago");
      });
  }

  public edit(uidElement: string): void {
    const elementSearched = this.dataSource.find(f => f.uid == uidElement);

    this.isEditMode = true;
    this.depositSaved = false;
    this.pagoCuotasPrestamos = elementSearched!;
  }

  public displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }

  public closeDialog(): void {
    this.dialogRef.close();
  }
  public trackByIndex(i: number) { return i; }

}